import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const { language, setLanguage, t } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleLangDropdown = () => {
    setIsLangDropdownOpen(!isLangDropdownOpen);
  };

  const handleLanguageChange = (lang: 'nl' | 'en') => {
    setLanguage(lang);
    setIsLangDropdownOpen(false);
  };

  const handleNavLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <a href="/">
            <img
              src="/assets/logos/Logo secundair.png"
              alt="Meijer & Knijnenberg"
              className="logo-image"
            />
          </a>
        </div>

        <button className="navbar-toggle" onClick={toggleMenu}>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <div className="navbar-item">
            <a href="/" onClick={handleNavLinkClick}>{t('nav.home')}</a>
          </div>

          <div className="navbar-item">
            <a href="/jobs" onClick={handleNavLinkClick}>{t('nav.jobs')}</a>
          </div>

          <div className="navbar-item">
            <a href="/about" onClick={handleNavLinkClick}>{t('nav.about')}</a>
          </div>

          <div className="navbar-item">
            <a href="/about#team" onClick={handleNavLinkClick}>{t('nav.contact')}</a>
          </div>

          {/* Send CV Button */}
          <div className="navbar-item navbar-cta">
            <a href="/cv" className="apply-button" onClick={handleNavLinkClick}>
              <svg className="send-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
              </svg>
              {t('nav.sendCV')}
            </a>
          </div>

          {/* Language Selector Dropdown */}
          <div className="navbar-item language-dropdown">
            <button
              className="lang-dropdown-btn"
              onClick={toggleLangDropdown}
              aria-label="Language selector"
            >
              <span className="flag">{language === 'nl' ? '🇳🇱' : '🇬🇧'}</span>
              <span className="lang-code">{language.toUpperCase()}</span>
              <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
              </svg>
            </button>
            {isLangDropdownOpen && (
              <div className="lang-dropdown-menu">
                <button
                  className={`lang-dropdown-item ${language === 'nl' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('nl')}
                >
                  <span className="flag">🇳🇱</span>
                  <span className="lang-text">NL</span>
                </button>
                <button
                  className={`lang-dropdown-item ${language === 'en' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('en')}
                >
                  <span className="flag">🇬🇧</span>
                  <span className="lang-text">EN</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
